<template>
  <div class="openapi-sign content-container">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="" name="1">
        <template slot="title">
          <h2>{{ $t("message.SignMethod") }}</h2>
        </template>
        <mavon-editor
            v-model="content"
            ref="md"
            @change="change"
            style="style"
            :defaultOpen="defaultOpen"
            :subfield="subfield"
            :toolbarsFlag="toolbarsFlag"
            :editable="editable"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  props: ['contentEditable', 'method'],
  data () {
    return {
      content: `
1. ${this.$t('message.SignMethod2')}
\`\`\`javascript
http://{openapiUrl}/?method=${this.method}&timestamp=2015-04-26%2000:00:07&format=xml&app_key={app_key}&v=2.0&sign=D06D88CB34B2EC0E5C9BAB396C9542B6&sign_method=md5&customerId={customerId}
\`\`\`
2. ${this.$t('message.SignMethod3')}
\`\`\`javascript
method=${this.method}
timestamp=2015-04-26 00:00:07
format=xml
app_key={app_key}
v=2.0
sign_method=md5
customerId={customerId}
\`\`\`
3. ${this.$t('message.SignMethod4')}
\`\`\`javascript
app_key={app_key}
customerId={customerId}
format=xml
method=${this.method}
sign_method=md5
timestamp=2015-04-26 00:00:07
v=2.0
\`\`\`
4. ${this.$t('message.SignMethod5')}
\`\`\`javascript
{secretkey}app_key{app_key}customerId{customerId}formatxmlmethod${this.method}sign_methodmd5timestamp2015-04-26 00:00:07v2.0{body}{secretkey}
\`\`\`
5. ${this.$t('message.SignMethod6')}

      `,
      editable: true,
      subfield: true,
      toolbarsFlag: true,
      defaultOpen: null,
      style: '',
      // activeNames: ['1']
    }
  },
  created () {
    setTimeout(() => {
      this.highlightRequired()
    }, 500)
  },
  methods: {
    change () {
      if (this.contentEditable) {
        this.subfield = true
        this.toolbarsFlag = true
        this.editable = true
        this.defaultOpen = null
        this.style = ''
      } else {
        this.subfield = false
        this.toolbarsFlag = false
        this.editable = false
        this.defaultOpen = 'preview'
        this.style = 'height: 100%'
      }
    },
    highlightRequired () {
      $.each($('.openapi-sign code'), (key, code) => {
        let html = $(code).html()
        html = html.replace(/{.*?}/g, function (match) {
          return `<span class="hljs-string">${match}</span>`
        })
        html = html.replace('D06D88CB34B2EC0E5C9BAB396C9542B6', '<span class="hljs-number">D06D88CB34B2EC0E5C9BAB396C9542B6</span>')
        $(code).html(html)
      })
    }
  },
  watch: {
    contentEditable: {
      handler (val, oldval) {
        this.change()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/openapi/OpenApiSign.vue